import { useI18n } from "@/i18n";
import { Reveal } from "./motion";
import { ArrowUpRight } from "lucide-react";

export const Expertise = () => {
  const { t } = useI18n();
  return (
    <section
      id="expertise"
      data-testid="expertise-section"
      className="bg-[#1c1c1a] py-28 text-[#f4f4f0] md:py-40"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <Reveal>
            <span className="font-body text-[11px] uppercase tracking-[0.28em] text-[#9e8d7b]">
              {t.expertise.label}
            </span>
            <h2 className="mt-6 max-w-2xl font-display text-4xl leading-[1.05] tracking-tight md:text-6xl">
              {t.expertise.heading}
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="max-w-xs font-body text-sm leading-relaxed text-[#9e8d7b]">
              {t.expertise.subtext}
            </p>
          </Reveal>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-px border border-[#3a3a37] bg-[#3a3a37] md:grid-cols-2">
          {t.services.map((s, i) => (
            <Reveal key={i} delay={i * 0.06}>
              <div
                data-testid={`service-${i}`}
                className="group h-full bg-[#1c1c1a] p-9 transition-colors duration-500 hover:bg-[#232320] md:p-12"
              >
                <div className="flex items-start justify-between">
                  <span className="font-display text-xl text-[#9e8d7b]">{String(i + 1).padStart(2, "0")}</span>
                  <ArrowUpRight
                    className="h-5 w-5 text-[#5c5c57] transition-all duration-500 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-[#f4f4f0]"
                    strokeWidth={1.25}
                  />
                </div>
                <h3 className="mt-8 font-display text-3xl tracking-tight md:text-4xl">{s.title}</h3>
                <p className="mt-5 max-w-md font-body text-base leading-relaxed text-[#b8b8b2]">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
